import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { getAppDialogProps } from "../utils/dialogLayer";

/**
 * Centered success dialog with custom next-step actions (setup wizard flow).
 */
export default function SetupNextStepDialog({
    open,
    onClose,
    title,
    description,
    actions = [],
}) {
    if (!open) return null;

    const dialogLayer = getAppDialogProps({
        paperSx: {
            borderRadius: 3,
            textAlign: "center",
            mx: 2,
            boxShadow: (t) => t.shadows[24],
        },
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="setup-next-step-title"
            {...dialogLayer}
        >
            <IconButton
                aria-label="Close"
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "text.secondary",
                    zIndex: 1,
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent sx={{ pt: 4, pb: 2, px: 3 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <CheckCircleOutlineIcon
                        sx={{ fontSize: 72, color: "success.main" }}
                        aria-hidden
                    />
                    <Typography id="setup-next-step-title" variant="h5" component="h2" fontWeight={700}>
                        {title}
                    </Typography>
                    {description ? (
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ maxWidth: 360, lineHeight: 1.5, whiteSpace: "pre-line" }}
                        >
                            {description}
                        </Typography>
                    ) : null}
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 3, pt: 0, px: 2 }}>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1.5}
                    sx={{ width: "100%", maxWidth: 420, justifyContent: "center" }}
                >
                    {actions.map((action) => (
                        <Button
                            key={action.label}
                            variant={action.variant || "contained"}
                            color={action.color || "primary"}
                            size="large"
                            onClick={action.onClick}
                            sx={{ borderRadius: 2, fontWeight: 600, minWidth: { sm: 140 } }}
                            fullWidth
                        >
                            {action.label}
                        </Button>
                    ))}
                </Stack>
            </DialogActions>
        </Dialog>
    );
}
